export default "__VITE_ASSET__4f332ab6__"